import { Check } from "lucide-react";
import { PRICING_PLANS } from "../../config/site";
import { ROUTES } from "../../config/routes";
import { CtaLink } from "../common/CtaLink";

const PlanCard = ({ p }) => (
  <article data-testid={`pricing-card-${p.id}`} className={`relative flex flex-col rounded-2xl border p-8 lg:p-10 ${p.highlight ? "border-[#FF5500]/50 bg-[#151824] shadow-[0_30px_80px_-40px_rgba(255,85,0,0.5)]" : "border-white/10 bg-[#0F111A]"}`}>
    {p.highlight && <span className="label-mono absolute -top-3 left-8 rounded bg-[#FF5500] px-2.5 py-1 text-white">Most complete</span>}
    <h2 className="font-display text-xl font-bold uppercase tracking-wider text-slate-50">{p.name}</h2>
    <p className="mt-3 text-sm text-slate-400">{p.summary}</p>
    <p className="mt-8 flex items-baseline gap-2">
      <span data-testid={`pricing-price-${p.id}`} className="font-display text-4xl font-extrabold text-slate-50">{p.price}</span>
      <span className="text-sm text-slate-500">{p.period}</span>
    </p>
    <ul className="mt-8 flex-1 space-y-3.5">
      {p.features.map((f) => (
        <li key={f} className="flex items-start gap-3 text-sm text-slate-300">
          <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#00E676]" aria-hidden="true" />{f}
        </li>
      ))}
    </ul>
    <CtaLink to={`${ROUTES.CONTACT}?plan=${p.id}`} variant={p.highlight ? "primary" : "ghost"} testId={`pricing-cta-${p.id}`} className="mt-10 justify-center">
      Register interest
    </CtaLink>
  </article>
);

export const PricingCards = () => (
  <div className="grid gap-6 lg:grid-cols-3">
    {PRICING_PLANS.map((p) => <PlanCard key={p.id} p={p} />)}
  </div>
);
